exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-list > div {\n  height: 100% !important; }\n\n.ant-spin-nested-loading {\n  height: 100%; }\n\n.ant-spin-container {\n  height: 100%; }\n\n.order-lines-input {\n  max-width: 70px !important; }\n\n.list-item-meta .ant-list-item-meta-avatar {\n  padding-top: 15px; }\n\n.list-item-meta .ant-list-item-meta-title {\n  padding-top: 12px; }\n\n.list-item-meta .ant-avatar-image {\n  border-radius: 0px !important;\n  background-color: transparent; }\n\n.ant-input-group-addon {\n  padding-left: 4px !important;\n  padding-right: 4px !important; }\n\n.bill-list-item {\n  height: 70px;\n  padding-left: 4px;\n  padding-right: 4px; }\n  .bill-list-item .bill-list-item-description {\n    position: absolute;\n    margin-top: 25px;\n    left: 53px; }\n    .bill-list-item .bill-list-item-description p {\n      text-overflow: ellipsis; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/order.scss
// module id = 691
// module chunks = 0